import { formatPercentage } from '../../packages/utils/numberFormatters'
import { getIntlLocale } from '../../i18n/localeUtils'
import { FeeListItem } from '@finance-lab/utils/types'
import { t } from 'i18next'

export function getFeeDescription(fee: FeeListItem, locale?: string) {
    const intlLocale = getIntlLocale(locale)
    const percent = (p: string | null) => formatPercentage(p, { locale: intlLocale, minDecimals: 0, maxDecimals: 1 })

    if (fee.feeCash && fee.feeUnits) {
        return `${percent(fee.feeCash)} ${t('components.utils.getFeeDescription.cash')} ${fee.feeBoth ? t('components.utils.getFeeDescription.and') : t('components.utils.getFeeDescription.or')} ${percent(
            fee.feeUnits,
        )} ${t('components.utils.getFeeDescription.inSharesUnits')}`
    }
    if (fee.feeCash) {
        return `${percent(fee.feeCash)} ${t('components.utils.getFeeDescription.cash')}.`
    }
    if (fee.feeUnits) {
        return `${percent(fee.feeUnits)} ${t('components.utils.getFeeDescription.inSharesUnits')}`
    }
    return null
}
